import React from "react";
import { makeStyles } from "@mui/styles";
import Grid from "@mui/material/Grid";
import classnames from "classnames";
import omit from "lodash/omit";
import { LOGIC_HELPERS } from "utils/helpers/logic";
import styles from "./styles";

const useStyles = makeStyles(styles);

function computeSizeProp(xs, sm, md, lg, xl) {
    const sizeProps = {};
    if (typeof xs !== "undefined") sizeProps.xs = xs;
    if (typeof sm !== "undefined") sizeProps.sm = sm;
    if (typeof md !== "undefined") sizeProps.md = md;
    if (typeof lg !== "undefined") sizeProps.lg = lg;
    if (typeof xl !== "undefined") sizeProps.xl = xl;

    const keys = Object.keys(sizeProps);

    if (keys.length === 1 && sizeProps[keys[0]] === true) {
        return "grow";
    }

    if (
        keys.length === 1 &&
        sizeProps[keys[0]] !== undefined &&
        sizeProps[keys[0]] !== true
    ) {
        return sizeProps[keys[0]];
    }

    if (keys.length > 1) {
        const value = {};
        keys.forEach((k) => {
            value[k] = sizeProps[k] === true ? "grow" : sizeProps[k];
        });
        return value;
    }

    return undefined;
}

const GridItem = React.forwardRef(function GridItem(props, ref) {
    const {
        children = null,
        grow,
        className,
        clickable,
        offsetTop4,
        offsetTop8,
        xs,
        sm,
        md,
        lg,
        xl,
        noMinWidth,
        ...other
    } = props;
    const classes = useStyles();

    const size = computeSizeProp(xs, sm, md, lg, xl);

    return (
        <Grid
            ref={ref}
            className={classnames(
                LOGIC_HELPERS.ifElse(grow, classes.grow),
                LOGIC_HELPERS.ifElse(clickable, classes.clickable),
                LOGIC_HELPERS.ifElse(offsetTop4, classes.offsetTop4),
                LOGIC_HELPERS.ifElse(offsetTop8, classes.offsetTop8),
                LOGIC_HELPERS.ifElse(noMinWidth, classes.noMinWidth),
                className
            )}
            size={size}
            {...omit(other, ["classes", "item"])}
        >
            {children}
        </Grid>
    );
});

export default GridItem;
